export enum FILE_FORMAT {
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  JSON = 'json',
  XLS = 'xls',
  CSV = 'csv',
}
